import React from 'react';
import './AboutUs.css';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/logo.png';

function AboutUs() {
  const navigate = useNavigate();
  return (
    <div className="about-us-container">
      <div className="about-us-image">
        <img src={Logo} alt="about us" />
      </div>
      <div className="about-us-content">
        <h1>About Us</h1>
        <p>
        6th KIPPRA Annual Regional Conference themed<span> Accelerating Economic Growth and Development for ASALs in Kenya...</span>
        </p>
        <button onClick={() => navigate('/conference')} className="more-button">More</button>
      </div>
    </div>
  );
}

export default AboutUs;
